import React, { useEffect, useMemo, useRef, useState } from 'react'
import Slider from 'react-slick'
import Container from '../container'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import styles from './person-articles.module.css'
import './slick.css'
import PersonArticlesCard from '../personFeaturingCard/PersonArticlesCard'
import Icon from '../icons'

const buildInternalArticleUrl = (slug) => {
  if (!slug) return null
  return `/content-hub/written/${slug}/`
}

const normalizeCategories = (node) => {
  if (Array.isArray(node?.categories) && node.categories.length > 0) {
    return node.categories
  }
  if (Array.isArray(node?.tags) && node.tags.length > 0) {
    return node.tags.map(tag => tag?.title).filter(Boolean)
  }
  return []
}

const normalizeArticle = (node) => {
  if (!node) return null

  const internalUrl = buildInternalArticleUrl(node?.slug?.current)
  const link = node?.openLink || node?.link || internalUrl

  return {
    id: node?.id || node?._id || link,
    title: node?.title,
    image: node?.mainImage || node?.featureImage,
    logo: node?.logo,
    link,
    categories: normalizeCategories(node),
    publishedAt: node?.publishedAt || null
  }
}

const sortByPublishedAt = (a, b) => {
  if (!a.publishedAt && !b.publishedAt) return 0
  if (!a.publishedAt) return -1
  if (!b.publishedAt) return 1
  return new Date(b.publishedAt) - new Date(a.publishedAt)
}

const PersonArticles = ({ name, relatedArticles = [], personArticles = [] }) => {
  const [currentSlide, setCurrentSlide] = useState(1)
  const [slideCount, setSlideCount] = useState(0)
  const sliderRef = useRef()

  const mergedArticles = useMemo(() => {
    const normalized = []
      .concat(relatedArticles || [])
      .concat(personArticles || [])
      .map(normalizeArticle)
      .filter(Boolean)

    const byUrl = new Map()
    normalized.forEach(item => {
      if (!item.link) return
      if (!byUrl.has(item.link)) byUrl.set(item.link, item)
    })

    return Array.from(byUrl.values()).sort(sortByPublishedAt)
  }, [relatedArticles, personArticles])

  const PrevArrow = ({ onClick }) => (
    <span className={`${styles.sliderLeft} ${currentSlide === 1 ? styles.disabled : ''}`} onClick={onClick}><Icon symbol='newChevronRight' /></span>
  )

  const NextArrow = ({ onClick }) => (
    <span className={`${styles.sliderRight} ${currentSlide === slideCount ? styles.disabled : ''}`} onClick={onClick}><Icon symbol='newChevronRight' /></span>
  )

  useEffect(() => {
    if (!sliderRef.current) return
    setSlideCount(Math.ceil(sliderRef.current.innerSlider.props.children.length - sliderRef.current.innerSlider.props.slidesToShow) + 1)
  }, [mergedArticles.length])

  const defaultSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    beforeChange: (current, next) => setCurrentSlide(next + 1),
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  }

  return (
    <Container>
      <div className={`${styles.root} ${styles.personFeaturing} person-featuring`}>
        <div className={styles.title}>
          Featuring <span>{name}</span>
        </div>
        <div className={styles.carouselWrap}>
          <Slider className={styles.caruselSlider} ref={sliderRef} {...defaultSettings}>
            {mergedArticles.map((node) => (
              <React.Fragment key={node.id || node.link}>
                <PersonArticlesCard
                  category={node.categories}
                  title={node.title}
                  logo={node.logo}
                  image={node.image}
                  link={node.link}
                  publishedAt={node.publishedAt}
                />
              </React.Fragment>
            ))}
          </Slider>
        </div>
      </div>
    </Container>
  )
}

export default PersonArticles
